
import jMoment from "moment-jalaali";
function GenerateDeviceId(len: number) {
    var arr = new Uint8Array((len || 40) / 2)
    window.crypto.getRandomValues(arr)
    var deviceId = Array.from(arr, dec2hex).join('');
    localStorage.setItem('did', deviceId);
    return deviceId;
}
export function getDeviceId(): string {
    var did = localStorage.getItem('did');
    if (!did) {
        var deviceId = GenerateDeviceId(10);
        return deviceId;
    }
    return did;
}
function dec2hex(dec: any) {
    return dec < 10
        ? '0' + String(dec)
        : dec.toString(16)
}
export function convertMildaiToShamsi(value: string|undefined) {
    if (value) {
        var date = jMoment(value, "YYYY-MM-DD").format("jDD-jMM-jYYYY");
        return date;
    }
    return "";
};
export function setLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
};
export function clearSession() {
    localStorage.removeItem('mySecurityToken');
    localStorage.removeItem('mySecurityData');

};
export function JsonIsValid(text: any) {
    if (text == null || text == undefined)
        return false;
    if (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@').
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

        return true;
    } else {

        return false;

    }
}

export function getToken() {
    var token = localStorage.getItem('mySecurityToken');
    return token ? token : '';
}
export function isEmpty(obj: any) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }

    return JSON.stringify(obj) === JSON.stringify({});
}


export const WebsocketEventName = {
    JoinService: 1,
    SendMessage: 2,
    ReceivedMessage: 3,
    ReadMessage: 4,
    ChangeStateCampigan: 5
}
export const PaymentType =
{
    Cash: 0,
    OnlinePayment: 1,
    Chek: 2,

}
export const InstallmentType =
{
    Peykan: 0,
    Samand: 1,
    Van: 2,
    MiniBus: 3,
}
export const ServiceType =
{
    Peykan: 0,
    Samand: 1,
    Van: 2,
    MiniBus: 3,
}

export function checkCodeMeli(code: string) {
    if (!code) {
        return false;
    }
    var L = code.length;

    if (L < 8 || parseInt(code, 10) == 0) return false;
    code = ('0000' + code).substr(L + 4 - 10);
    if (parseInt(code.substr(3, 6), 10) == 0) return false;
    var c = parseInt(code.substr(9, 1), 10);
    var s = 0;
    for (var i = 0; i < 9; i++)
        s += parseInt(code.substr(i, 1), 10) * (10 - i);
    s = s % 11;
    return (s < 2 && c == s) || (s >= 2 && c == (11 - s));

}
function timeToMins(time: string) {
    var b = time.split(':');
    return Number(b[0]) * 60 + Number(b[1]);
}

// Convert minutes to a time in format hh:mm
// Returned value is in range 00  to 24 hrs
function timeFromMins(mins: number) {
    function z(n: number) { return (n < 10 ? '0' : '') + n; }
    var h = (mins / 60 | 0) % 24;
    var m = mins % 60;
    return z(h) + ':' + z(m);
}

// Add two times in hh:mm format
export function sumTimes(t0: string, t1: string) {
    return timeFromMins(timeToMins(t0) + timeToMins(t1));
}
export function convertTimeSpanToString(time: number) {
    var totalMin = Math.floor(time / (1000 * 60));
    var timeLeftStr = "00:00:00";
    if (totalMin >= 60) {
        var hour = Math.floor(totalMin / 60);
        var min = totalMin % 60;
        timeLeftStr = ('0' + hour).slice(-2) + ":" + ('0' + min).slice(-2) + ":00";
    }
    else
        timeLeftStr = "00:" + ('0' + totalMin).slice(-2) + ":00";
    return timeLeftStr;
}